module.exports = __webpack_public_path__ + "media/images/top-content-img-2-a9a48dfb43d0d74c050e3b1f43083148.jpg";